/**
 * @generated SignedSource<<43f606d45d0a6b031f80d6305a2ade11>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentMethodInfoContent_PaymentOption$data = {
  readonly total: {
    readonly amount: number;
  };
  readonly installments: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly interestRate: number;
        readonly quantity: number;
        readonly total: {
          readonly amount: number;
        };
        readonly value: {
          readonly amount: number;
        };
      };
    }>;
  };
  readonly " $fragmentSpreads": FragmentRefs<"utils_PaymentOption">;
  readonly " $fragmentType": "PaymentMethodInfoContent_PaymentOption";
};
export type PaymentMethodInfoContent_PaymentOption$key = {
  readonly " $data"?: PaymentMethodInfoContent_PaymentOption$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentMethodInfoContent_PaymentOption">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  }
],
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "Money",
  "kind": "LinkedField",
  "name": "total",
  "plural": false,
  "selections": (v0/*: any*/),
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "interestRate",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Money",
  "kind": "LinkedField",
  "name": "value",
  "plural": false,
  "selections": (v0/*: any*/),
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentMethodInfoContent_PaymentOption",
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "PaymentOptionInstallmentConnection",
      "kind": "LinkedField",
      "name": "installments",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PaymentOptionInstallmentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PaymentOptionInstallment",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "quantity",
                  "storageKey": null
                },
                (v1/*: any*/),
                (v3/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "utils_PaymentOption",
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "PaymentOptionInstallmentConnection",
          "kind": "LinkedField",
          "name": "installments",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PaymentOptionInstallmentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PaymentOptionInstallment",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v2/*: any*/),
                    (v1/*: any*/),
                    (v3/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "PaymentOption",
  "abstractKey": null
};
})();

(node as any).hash = "344e3de3377a9aaaccbc1e1d12de8743";

export default node;
